// languages/french.js
export const french = {
  name: "Française",
  interface: {
    welcome: "Bienvenue",
    chooseLanguage: "Choisissez la langue",
    continue: "Continuer",
    backToMap: "Retour à la carte",
    achievement: "Succès",
    viewInAR: "Voir en AR",
    menu: {
      menu: "Menu",
      home: "Accueil",
      language: "Langue",
      achievement: "Succès",
      unsuiExperience: "Expérience Unsui",
      feedback: "Retour",
    },
    buyScreen: {
      clickToBuy: "Cliquez pour acheter une expérience",
      templeExperience: "spéciale au temple !",
      description1: "Écoutez des histoires fascinantes sur",
      description2: "le temple avec un guide audio et profitez",
      description3: "d'une expérience AR magique !",
      buy: "Acheter",
    },
    gift: {
      congratulations: "Félicitations !",
      yourGift: "Votre cadeau",
      giftTitle: "The Supreme Truth",
      giftText: "Check out this amazing gift!",
    },
  },
};
